export default class ResetPasswordDto {
    code: string;
    password: string;

    constructor(data: any) {
        this.code = data.code;
        this.password = data.password;
    }
}